import { render, staticRenderFns } from "./EditDirectionUniversityModal.vue?vue&type=template&id=596468e2&scoped=true&"
import script from "./EditDirectionUniversityModal.vue?vue&type=script&lang=js&"
export * from "./EditDirectionUniversityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596468e2",
  null
  
)

export default component.exports